<!-- eslint-disable no-await-in-loop -->
<template>
  <div class="step-dynamic">
    <Modal
      :active="active"
      name="StepDynamicModal"
      :class="{ 'for-mobile-app': isMobileApp }"
      @close.prevent="closeModal"
      title="Мои шаги"
    >
      <!-- Табы -->
      <div class="step-dynamic__buttons">
        <div
          class="step-dynamic__button"
          :class="{ active: activeTab === 'Daily' }"
          @click="setActiveTab('Daily')"
        >День</div>
        <div
          class="step-dynamic__button"
          :class="{ active: activeTab === 'Weekly' }"
          @click="setActiveTab('Weekly')"
        >Неделя</div>
        <div
          class="step-dynamic__button"
          :class="{ active: activeTab === 'Monthly' }"
          @click="setActiveTab('Monthly')"
        >Месяц</div>
      </div>
      <!-- Отображение активного таба -->
      <div v-if="activeTab === 'Daily'" :key="'day-' + activeTab">
        <DailyTab @changeTarget="changeTarget" @goRating="goRating" />
      </div>
      <div v-if="activeTab === 'Weekly'" :key="'week-' + activeTab">
        <WeekTab @goRating="goRating" />
      </div>
      <div class="step-dynamic__month" v-if="activeTab === 'Monthly'" key="month">
        <MonthTab @goRating="goRating" />
      </div>
    </Modal>
  </div>
</template>

<script>
import DailyTab from './DailyTab.vue';
import WeekTab from './WeekTab.vue';
import MonthTab from './MonthTab.vue';

export default {
  name: 'StepDynamicModal',
  components: {
    DailyTab,
    WeekTab,
    MonthTab,
  },
  props: {
    active: Boolean,
    isMobileApp: Boolean,
  },
  data() {
    return {
      activeTab: 'Daily',
    };
  },
  watch: {
    active(newVal) {
      if (newVal) {
        this.setActiveTab('Daily');
      }
    },
  },

  methods: {
    setActiveTab(tab) {
      this.activeTab = tab;
    },
    changeTarget() {
      this.setActiveTab('');
      this.$emit('changeTarget');
    },
    goRating() {
      this.$emit('goRating');
    },
    closeModal() {
      this.setActiveTab('');
      this.$emit('close');
    },
  },
  async mounted() {
    this.setActiveTab('');
  },
};
</script>

<style lang="scss" scoped>
@import './StepDynamicModal';

</style>
